import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';

import styles from './filterMenu.css';

const FilterMenu = ({ children, wrapperClasses }) => (
  <div className={classNames(styles.wrapper, [wrapperClasses])}>
    <form action="/" className={styles.form}>
      <div className={classNames(styles.inner, 'filterMenu__inner')}>
        {children}
      </div>
    </form>
  </div>
);

FilterMenu.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.element),
    PropTypes.node,
  ]).isRequired,
  wrapperClasses: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.array,
  ]),
};

FilterMenu.defaultProps = {
  wrapperClasses: '',
};

export default withStyles(styles)(FilterMenu);
